import { createComponent } from '@lit-labs/react';
import React from 'react';

export class RadioButtonCardDS extends HTMLElement {
  selected?: boolean;
  value?: string | null;
  tabindex?: string | null;
  constructor() {
    super();
  }
}

export const RadioButtonCard = createComponent(React, 'radio-button-card', RadioButtonCardDS, {
  onSelectedChange: 'selected-changed',
});
